import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { Decor } from '../models/decor';

@Injectable({
  providedIn: 'root'
})
export class DecorService extends BaseService<Decor>  {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string                
  ) { 
    super(http,rootUrl,'Plasard/Decor');
  }
}
